import { fetchGracenoteLineups } from "core/API/GameMasterLineup";
import Cookies from "js-cookie";

export const fetchGracenoteDefaults = async () => {

    const workplaceId = Number(localStorage.getItem("workplace-id"));
    const lineupsData = await fetchGracenoteLineups(workplaceId);
}